<!-- EDI申込内容確認ダイアログ（参照のみ） -->
<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    scrollable
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title class="text-h6 font-weight-bold">
        EDI申込内容確認
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <edi-confirm-table :form-data="formData" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          @click="closeDialog"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EdiConfirmTable from '@/components/EdiConfirmTable'

export default {
  name: 'EdiApplicationConfirmDialog',
  components: {
    EdiConfirmTable,
  },
  props: {
    enableDialog: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dialog: {
      get() { return this.enableDialog },
      set(val) { if (!val) this.closeDialog() }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeCallback')
    }
  }
}
</script>
